import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const ReceiptsPage = lazy(() => import("@/pages/payments.receipts.page"));

export const Route = createFileRoute("/payments/receipts")({
  component: ReceiptsPage,
});
